// extracted by mini-css-extract-plugin
export default {"input-wrapper":"MultiSelectDropdown_input-wrapper__w06T5"};